import { render, staticRenderFns } from "./requestlist.vue?vue&type=template&id=5d9ee68d"
import script from "./requestlist.vue?vue&type=script&lang=js"
export * from "./requestlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports